import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/signIn/user.signIn.query.gql"
import type {
  UserSignInQuery,
  UserSignInQueryVariables,
} from "@/v2-backoffice-client/user/signIn/__types__/user.signIn.query"

type Options = QueryHookOptions<UserSignInQuery, UserSignInQueryVariables>

export function useUserSignInQuery(options?: Options) {
  return useQuery<UserSignInQuery, UserSignInQueryVariables>(query, options)
}
